export const MONITOR_TOKEN_KEY = 'errorMonitorAccessToken'

export function getMonitorToken () {
  const token = sessionStorage.getItem(MONITOR_TOKEN_KEY)
  return token && token.trim() ? token : null
}

export function setMonitorToken (token) {
  sessionStorage.setItem(MONITOR_TOKEN_KEY, token)
}

export function clearMonitorToken () {
  sessionStorage.removeItem(MONITOR_TOKEN_KEY)
}
